<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    width="600"
    height="600"
    viewBox="0 0 600 600"
    version="1.1"
    class="img-fluid"
  >
    <defs
      id="defs740"
    >
      <filter
        id="filter1_d"
        x="0"
        y="175"
        width="108"
        height="108"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          id="feFlood535"
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          id="feColorMatrix537"
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset
          id="feOffset539"
        />
        <feGaussianBlur
          id="feGaussianBlur541"
          stdDeviation="5"
        />
        <feColorMatrix
          id="feColorMatrix543"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
        />
        <feBlend
          id="feBlend545"
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          id="feBlend547"
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>

    <g transform="translate(14 236)">
      <g
        v-for="(item, index) in archetypes"
        :id="`layer-${item.tag}`"
        :key="item.id"
        :transform="`rotate(${30 * index} 285 63)`"
        :class="`layer ${isActive(item.id) ? 'active' : ''} ${item.tag === hover ? 'hover' : ''}`"
      >
        <g transform="scale(4.6) translate(-62.435589,-128.01999)">
          <path
            d="m 111.95078,140.17917 v 3.90737 c 0,0.59743 -0.40032,1.12077 -0.97685,1.27688 l -29.856401,8.09096 c -0.83256,0.22542 -1.65486,-0.39318 -1.66875,-1.25572 l -0.31658,-19.62679 c -0.014,-0.87074 0.80264,-1.51738 1.64701,-1.30387 l 30.172761,7.62874 c 0.58738,0.14843 0.99881,0.6768 0.99881,1.28243 z"
            :fill="colors[item.tag]"
            style="stroke-width:0.264583"
          />
          <g
            filter="url(#filter1_d)"
            transform="matrix(0.26458333,0,0,0.26458333,62.435589,81.717903)"
          >
            <circle
              cx="54"
              cy="229"
              r="44"
              fill="#ffffff"
            />
            <circle
              cx="54.229527"
              cy="229"
              :stroke="colors[item.tag]"
              stroke-width="1.5"
              style="fill:#ffffff"
              r="43.25"
            />
            <image
              :xlink:href="$publicPath + 'img/archetypes/' + item.tag + '.svg'"
              x="0"
              y="0"
              transform="rotate(-90 141 120)"
            />
          </g>
        </g>
        <g
          :transform="index > 3 && index < 10 ? 'rotate(180 165 64)' : null"
        >
          <text
            y="61"
            x="165"
            class="text-name"
            text-anchor="middle"
            :fill="isActive(item.id) ? colors[item.tag] : null"
          >
            {{ item.name }}
          </text>
          <text
            y="75"
            x="165"
            fill="white"
            class="text-subname"
            text-anchor="middle"
          >
            {{ item.subname }}
          </text>
        </g>
        <g
          transform="scale(4.6) translate(-62.435589,-128.01999)"
          class="action-layer"
        >
          <path
            d="m 111.95078,140.17917 v 3.90737 c 0,0.59743 -0.40032,1.12077 -0.97685,1.27688 l -29.856401,8.09096 c -0.83256,0.22542 -1.65486,-0.39318 -1.66875,-1.25572 l -0.31658,-19.62679 c -0.014,-0.87074 0.80264,-1.51738 1.64701,-1.30387 l 30.172761,7.62874 c 0.58738,0.14843 0.99881,0.6768 0.99881,1.28243 z"
            fill-opacity="0"
            style="stroke-width:0.264583"
            @click="setArchetype(item.id)"
            @mouseover="hoverHandleEnter(item.tag)"
            @mouseleave="hoverHandleLeave()"
          />
          <g
            filter="url(#filter1_d)"
            transform="matrix(0.26458333,0,0,0.26458333,62.435589,81.717903)"
          >
            <circle
              cx="54.229527"
              cy="229"
              stroke-width="1.5"
              fill-opacity="0"
              stroke-opacity="0"
              r="43.25"
              @click="setArchetype(item.id)"
              @mouseover="hoverHandleEnter(item.tag)"
              @mouseleave="hoverHandleLeave()"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, Array],
      default: null
    }
  },
  data () {
    return {
      colors: {
        innocent: '#e65eae',
        sage: '#4c5bde',
        explorer: '#df1f5a',
        outlaw: '#e65eae',
        magician: '#4c5bde',
        hero: '#35c5ef',
        lover: '#2db67d',
        jester: '#df1f5a',
        everyman: '#e65eae',
        caregiver: '#4c5bde',
        ruler: '#35c5ef',
        creator: '#2db67d'
      },
      hover: null
    }
  },
  computed: {
    archetypes () {
      const archetypes = this.$store.state.archetypes.items
      if (archetypes) {
        const result = []
        for (const item of archetypes) {
          result.push(this.$store.getters['archetypes/getByTag'](item.tag))
        }
        return result
      } else {
        return []
      }
    }
  },
  created () {
    if (this.$store.state.archetypes.items.length === 0) {
      this.$store.dispatch('archetypes/get')
    }
  },
  methods: {
    isActive (archetypeId) {
      if (Array.isArray(this.value)) {
        return this.value.includes(archetypeId)
      } else {
        return archetypeId === this.value
      }
    },
    setArchetype (archetypeId) {
      if (Array.isArray(this.value)) {
        if (this.value.includes(archetypeId)) {
          this.$emit('input', this.value.filter(item => item !== archetypeId))
        } else {
          this.$emit('input', [...this.value, archetypeId])
        }
      } else {
        this.$emit('input', archetypeId)
      }
    },
    hoverHandleEnter (tag) {
      this.hover = tag
    },
    hoverHandleLeave () {
      this.hover = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .text-name, .text-subname {
    text-align: center;
    font-weight: 600;
  }
  .text-name {
    font-size: 0.75rem;
  }
  .text-subname {
    font-size: 0.625rem;
    color: white;
  }
  path, circle {
    cursor: pointer;
    transition: 0.2s;
  }
  .layer.hover, .layer.active {
    path {
      fill: $warning;
    }
    circle {
      stroke: $warning;
    }
  }
</style>
